import type { CardInput, IProvider } from '../types';

const STRIPE_API = 'https://api.stripe.com/v1';

export class StripeProvider implements IProvider {
  constructor(
    private readonly publicKey: string,
    private readonly gatewayConfigId: string,
  ) {}

  async generate(card: CardInput): Promise<string> {
    const [month, year] = card.expiration.split('/');

    const body = new URLSearchParams({
      'card[number]': card.number.replace(/\s/g, ''),
      'card[exp_month]': month,
      'card[exp_year]': year,
      'card[cvc]': card.cvv,
    });

    const response = await fetch(`${STRIPE_API}/tokens`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: `Bearer ${this.publicKey}`,
      },
      body: body.toString(),
    });

    if (!response.ok) {
      const error = await response.text();
      throw new Error(`Stripe tokenize failed: ${error}`);
    }

    const data = (await response.json()) as { id: string };
    return data.id;
  }
}
